// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__crdug","pageContainer":"PageHeader_pageContainer__FOaRw","pageHeading":"PageHeader_pageHeading__zFBiW","pagePara":"PageHeader_pagePara__sfzGG"};